import { render, staticRenderFns } from "./custosVariaveis.vue?vue&type=template&id=4739ee1c&scoped=true&"
import script from "./custosVariaveis.vue?vue&type=script&lang=js&"
export * from "./custosVariaveis.vue?vue&type=script&lang=js&"
import style0 from "./custosVariaveis.vue?vue&type=style&index=0&id=4739ee1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4739ee1c",
  null
  
)

export default component.exports